'use strict';

var isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';
var isInternetExplorer = isBrowser && Boolean(window.MSInputMethodContext && document.documentMode);
var isSafari = isBrowser && /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
var hasTouchSupport = isBrowser && 'ontouchstart' in window;
function createEvent(name) {
    if (isInternetExplorer) {
        var ev = document.createEvent('Event');
        ev.initEvent(name, true);
        return ev;
    }
    return new Event(name, { bubbles: true });
}

exports.createEvent = createEvent;
exports.hasTouchSupport = hasTouchSupport;
exports.isBrowser = isBrowser;
exports.isInternetExplorer = isInternetExplorer;
exports.isSafari = isSafari;
//# sourceMappingURL=env-100217af.js.map
